import VideoLectureDetails from '../views/VideoLectureDetails';
import UploadVideoLecture from '../views/UploadVideoLecture';
import EditVideoLecture from '../views/EditVideoLecture';
import VideoLectureList from '../views/VideoLectureList';

const router = [
  {
    name: 'videoLectures.videoLectureList',
    path: '/video-lectures',
    component: VideoLectureList,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoLectures.uploadVideoLecture',
    path: '/upload-video-lecture',
    component: UploadVideoLecture,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoLectures.newVideoLecture',
    path: '/new-video-lecture',
    component: EditVideoLecture,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoLectures.videoLectureDetails',
    path: '/video-lectures/:lecture_id',
    component: VideoLectureDetails,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoLectures.editVideoLecture',
    path: '/video-lectures/:lecture_id/edit',
    component: EditVideoLecture,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/video-lectures/router/index.js